import AudienceHubPage from "@/components/AudienceHubPage";
import { IMG } from "@/lib/data";
import { STATUS } from "@/lib/status";

const PROGRAMMES = [
  {
    id: "create-your-own-magic",
    title: "Create Your Own Magic",
    desc: "A school-day workshop combining storytelling, projection and creative tech. KS2–KS3.",
    image: IMG.xrTheatre,
    focal: "center",
    status: STATUS.BOOKING_OPEN,
    href: "/whats-on?filter=academy",
    eyebrow: "KS2–KS3 · Booking open",
  },
  {
    id: "multibrush-street-dance-vr",
    title: "Multibrush Street Dance VR",
    desc: "Students step into VR to choreograph and visualise street dance in 3D. KS3–KS5.",
    image: IMG.vr || IMG.heroPortal,
    focal: "center",
    status: STATUS.BOOKING_OPEN,
    eyebrow: "KS3–KS5 · Booking open",
  },
  {
    id: "projection-mapping-workshop",
    title: "Projection Mapping Workshop",
    desc: "A hands-on session turning a classroom wall into a living canvas. KS3–KS5.",
    image: IMG.corporate,
    focal: "center",
    status: STATUS.BOOKING_OPEN,
    eyebrow: "KS3–KS5 · Booking open",
  },
  {
    id: "xr-performance-integration",
    title: "XR & Performance Integration",
    desc: "Full-week residency embedding XR into a school's drama or dance department.",
    image: IMG.levelUp,
    focal: "center",
    status: STATUS.REGISTER_INTEREST,
    eyebrow: "KS3–KS5 · Register interest",
  },
  {
    id: "ai-storytelling-schools",
    title: "AI Storytelling for Schools",
    desc: "Generative storytelling tools used responsibly with year groups exploring narrative.",
    image: IMG.heroPortal,
    focal: "center",
    status: STATUS.IN_DEVELOPMENT,
    eyebrow: "KS3–KS5 · In development",
  },
  {
    id: "schools-festival-residency",
    title: "Schools Festival Residency",
    desc: "Multi-school cohort culminating in a public XR showcase as part of TOK XR Festival.",
    image: IMG.immersiveNights,
    focal: "center",
    status: STATUS.COMING_SOON,
    eyebrow: "Cross-school · Coming soon",
  },
];

export default function Schools() {
  return (
    <AudienceHubPage
      testIdRoot="schools"
      pageSource="schools"
      seo={{
        title: "VR Workshops & Creative Technology for Schools — Temple of Kulture",
        description:
          "Multibrush Street Dance VR, projection mapping workshops and XR performance integration. Creative technology education for primary, secondary and SEN schools across the UK.",
        image: IMG.xrTheatre,
      }}
      hero={{
        eyebrow: "For Schools & Educators",
        headline: "Creative technology, into your classroom.",
        subhead:
          "Multibrush Street Dance VR, projection mapping workshops, XR performance integration — designed for primary, secondary and SEN. Linked to curriculum, rooted in culture.",
        image: IMG.xrTheatre,
        focal: "50% 45%",
        primaryCta: { label: "Enquire about a booking", to: "/corporate" },
      }}
      identity={{
        eyebrow: "Why schools choose us",
        headline: "Immersive learning that actually moves the needle.",
        body:
          "Our workshops are designed with classroom teachers, not just for them. Every session ties into a curriculum outcome, captures the imagination of students often overlooked by mainstream STEM, and gives schools a public showcase to take back to parents and inspectors.",
      }}
      programmes={PROGRAMMES}
      trustLine="Delivered with schools across Medway, Kent and London — and via the TOK XR Festival, with cross-school showcases reaching 2,000+ students annually."
      faqs={[
        {
          q: "What age groups do you work with?",
          a: "We work with KS2 through KS5 (ages 7–18), with bespoke programmes for SEN settings. Get in touch with year-group details and we'll design accordingly.",
        },
        {
          q: "What equipment do you bring?",
          a: "We bring everything needed — VR headsets, projection rigs, laptops, and our facilitators. Your school needs a darkenable room and (ideally) a power supply nearby.",
        },
        {
          q: "How much does a session cost?",
          a: "Costs depend on duration, year-group size and whether it's a single workshop or a multi-week residency. We have funded slots available — please enquire.",
        },
        {
          q: "Do you cover curriculum outcomes?",
          a: "Yes. Each programme maps to Art & Design, Drama, Computing and PSHE outcomes. We share the mapping document on enquiry.",
        },
      ]}
      finalCta={{
        eyebrow: "Bookings open for Spring & Summer terms",
        headline: "Bring TOK into your school.",
        body: "Tell us about your year group, term dates and goals. We'll come back within 48h with options and pricing.",
        label: "Start an enquiry",
        to: "/corporate",
        bullets: [
          "Single workshops or full residencies",
          "All equipment provided",
          "Curriculum-mapped",
        ],
      }}
      stayWhatsAppCopy={{
        headline: "STAY CLOSE TO THE STUDIO",
        tagline: "Schools programme launches, INSET days, and free CPD opportunities — sent direct to your WhatsApp.",
        bullets: [
          "New schools programmes",
          "Free CPD opportunities for teachers",
          "INSET-day immersive sessions",
          "Schools festival announcements",
          "Funding & bursary alerts",
        ],
      }}
    />
  );
}
